import { Link } from 'react-router-dom';
import cn from 'bem-cn';

import { TagProps } from './Tag.types';
import './Tag.scss';

const b = cn('tag');

export const Tag = ({ text, link, onClick, size = 'small' }: TagProps) => {
    const className = b({ clickable: Boolean(link), size: size });

    if (link) {
        return (
            <Link to={link} className={className} onClick={onClick}>
                {text}
            </Link>
        );
    }

    return <span className={className}>{text}</span>;
};
